import { accountUrl } from '../api-origin.js'

// Existing shared links and Studio previews keep opening the game after the
// public root becomes the landing page. Campaign parameters stay on the site.
const GAME_INTENTS = ['play', 'auth', 'returnTo', 'story', 'sharedSave', 'save', 'storeGame', 'studioPreview', 'discover', 'debug', 'avatar']

export function gameEntryDestination(search = '', hash = '') {
  const params = new URLSearchParams(search)
  if (params.has('sharedSave')) return accountUrl(`/shared-saves/${encodeURIComponent(params.get('sharedSave'))}`)
  if (!GAME_INTENTS.some(key => params.has(key))) return null
  return `/play.html${search.startsWith('?') || !search ? search : `?${search}`}${hash.startsWith('#') ? hash : ''}`
}

export function requestsDiscovery(search = '') {
  const params = new URLSearchParams(search)
  return params.get('discover') === '1' && !['story', 'sharedSave', 'save', 'storeGame', 'studioPreview'].some(key => params.has(key))
}
